import {
  AccreditationHealthStatus,
  AccreditationPendingStatus,
} from 'src/v3/content-pipeline/accreditation-health.slice'

type ChipColor = 'default' | 'success' | 'warning' | 'error' | 'info'

export let STATUS_META: Record<
  AccreditationHealthStatus,
  { label: string; color: ChipColor }
> = {
  missing: { label: 'Missing', color: 'error' },
  notPursued: { label: 'Not Pursued', color: 'default' },
  noExpirationDate: { label: 'No Expiration', color: 'default' },
  current: { label: 'Current', color: 'success' },
  approaching: { label: 'Approaching', color: 'warning' },
  expired: { label: 'Expired', color: 'error' },
}

export let PENDING_META: Record<
  AccreditationPendingStatus,
  { label: string; color: ChipColor; description: string }
> = {
  draft: { label: 'Draft', color: 'default', description: 'Draft in progress' },
  submitted: {
    label: 'Submitted',
    color: 'info',
    description: 'Submitted for review',
  },
  approved: {
    label: 'Approved',
    color: 'warning',
    description: 'Approved — awaiting finalize',
  },
  rejected: {
    label: 'Rejected',
    color: 'error',
    description: 'Rejected — needs revision',
  },
}

// Worst-first ordering: lower score sorts earlier. notPursued is an
// intentionally-accepted gap, not an open one — it sorts alongside current,
// well below anything still actionable.
let STATUS_SEVERITY: Record<AccreditationHealthStatus, number> = {
  expired: 0,
  missing: 1,
  approaching: 2,
  noExpirationDate: 3,
  notPursued: 4,
  current: 4,
}

let PENDING_SEVERITY: Record<AccreditationPendingStatus, number> = {
  rejected: 0,
  submitted: 1,
  draft: 2,
  approved: 3,
}

export function accreditationSeverityScore(
  status: AccreditationHealthStatus,
  pending?: AccreditationPendingStatus | null,
): number {
  let base = STATUS_SEVERITY[status] * 10
  let pendingScore = pending ? PENDING_SEVERITY[pending] : 9
  return base + pendingScore
}

// "Nothing to do here" — either genuinely current, or intentionally flagged
// as not pursued, with no update in flight either way.
export function isFullyCurrent(
  status: AccreditationHealthStatus,
  pending?: AccreditationPendingStatus | null,
): boolean {
  return (status === 'current' || status === 'notPursued') && !pending
}
